// components/common/ModalTitle.jsx
import React from "react";

const ModalTitle = ({ title }) => {
  return (
    <div className="bg-gradient-to-r from-[#09274A] to-[#0488AF] rounded-t-lg p-5 mb-6">
      <h2 className="text-xl font-semibold text-white px-3">{title}</h2>
    </div>

  );
};

export default ModalTitle;